import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Send } from "lucide-react";

export function OfferDialog({ tenant, open, onClose, onSent, prefill }) {
  const [f, setF] = useState({ title: "", address: "", rent: "", lease_length_months: 12, move_in_date: "", deposit: "", incentives: "", notes: "" });
  useEffect(() => { if (prefill) setF((p) => ({ ...p, ...prefill })); }, [prefill]);
  const submit = async () => {
    try {
      await api.post("/offers", {
        tenant_id: tenant.user_id,
        property_id: prefill?.property_id || null,
        title: f.title, address: f.address,
        rent: Number(f.rent), lease_length_months: Number(f.lease_length_months),
        move_in_date: f.move_in_date, deposit: Number(f.deposit),
        incentives: f.incentives.split(",").map((s) => s.trim()).filter(Boolean),
        notes: f.notes,
      });
      toast.success("Offer sent!");
      onSent();
      onClose();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed to send"); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg">
        <DialogHeader><DialogTitle>Send offer to {tenant?.name}</DialogTitle></DialogHeader>
        <div className="space-y-3 max-h-[60vh] overflow-y-auto pr-1">
          <div><Label>Property title</Label><Input data-testid="offer-title" value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} /></div>
          <div><Label>Address</Label><Input data-testid="offer-address" value={f.address} onChange={(e) => setF({ ...f, address: e.target.value })} /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Rent ($/mo)</Label><Input data-testid="offer-rent" type="number" value={f.rent} onChange={(e) => setF({ ...f, rent: e.target.value })} /></div>
            <div><Label>Deposit ($)</Label><Input data-testid="offer-deposit" type="number" value={f.deposit} onChange={(e) => setF({ ...f, deposit: e.target.value })} /></div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Lease (months)</Label><Input data-testid="offer-lease" type="number" value={f.lease_length_months} onChange={(e) => setF({ ...f, lease_length_months: e.target.value })} /></div>
            <div><Label>Move-in date</Label><Input data-testid="offer-movein" type="date" value={f.move_in_date} onChange={(e) => setF({ ...f, move_in_date: e.target.value })} /></div>
          </div>
          <div><Label>Incentives (comma separated)</Label><Input data-testid="offer-incentives" value={f.incentives} onChange={(e) => setF({ ...f, incentives: e.target.value })} placeholder="1 month free, parking included" /></div>
          <div><Label>Notes</Label><Textarea data-testid="offer-notes" value={f.notes} onChange={(e) => setF({ ...f, notes: e.target.value })} rows={3} /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button data-testid="offer-submit" onClick={submit}><Send className="w-4 h-4 mr-1" /> Send offer</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
